import { createActionGroup, props } from '@ngrx/store';
import type { CategoryAllowedOsUpdate } from '@rocksoft/shared';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryAllowedOsUpdatesResolverActions = createActionGroup({
  source: 'Location Allowed OS Updates resolver',
  events: {
    requested: props<{ categoryId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const LocationAllowedOsUpdatesApiActions = createActionGroup({
  source: 'Location Allowed OS Updates API',
  events: {
    loaded: props<{ categoryAllowedOsUpdates: CategoryAllowedOsUpdate[] }>(),
    'loaded error': props<{ error: ErrorModel }>(),
    updated: props<{ categoryId: string; categoryAllowedOsUpdates: CategoryAllowedOsUpdate[] }>(),
    'updated error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CurrentLocationViewActions = createActionGroup({
  source: 'Current location view',
  events: {
    Update: props<{ categoryId: string; categoryAllowedOsUpdates: CategoryAllowedOsUpdate[] }>(),
  },
});
